import type { Event } from 'models';
import { Alert } from 'ui';
import { isAfterJoinPeriod } from '../../../utils';

type P = {
  event: Event;
};

const EventJoinStatusAlerts = ({ event }: P) => {
  if (isAfterJoinPeriod(event.endTime)) {
    return <Alert title="This event has ended" />;
  }

  return <Alert title="You must be logged in to enter this event" />;
};

export default EventJoinStatusAlerts;
